/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DevelopmentRegistrationStep = "first_buyer" | "result" | "second_buyer" | "verification";
export type UpsertDevelopmentRegistrationFormInput = {|
  developmentRegistrationForm?: ?DevelopmentRegistrationFormInput,
  clientMutationId?: ?string,
|};
export type DevelopmentRegistrationFormInput = {|
  id?: ?string,
  productId?: ?string,
  developmentProductId?: ?string,
  firstBuyerFirstName?: ?string,
  firstBuyerLastName?: ?string,
  firstBuyerEmailAddress?: ?string,
  firstBuyerPhoneNumber?: ?string,
  emailAddress?: ?string,
  phoneNumber?: ?string,
  numberOfBuyers?: ?number,
  isAlreadyOwner?: ?boolean,
  inviteSecondBuyer?: ?boolean,
  firstBuyerDateOfBirth?: ?string,
  firstBuyerOccupationId?: ?string,
  firstBuyerNationalityId?: ?string,
  firstBuyerWorkPermitId?: ?string,
  firstBuyerAnnualRevenues?: ?number,
  firstBuyerSavings?: ?number,
  firstBuyerUseOfSecondPillar?: ?boolean,
  firstBuyerSecondPillar?: ?number,
  firstBuyerUseOfThirdPillar?: ?boolean,
  firstBuyerThirdPillar?: ?number,
  secondBuyerFirstName?: ?string,
  secondBuyerLastName?: ?string,
  secondBuyerEmailAddress?: ?string,
  secondBuyerPhoneNumber?: ?string,
  secondBuyerDateOfBirth?: ?string,
  secondBuyerOccupationId?: ?string,
  secondBuyerNationalityId?: ?string,
  secondBuyerWorkPermitId?: ?string,
  secondBuyerAnnualRevenues?: ?number,
  secondBuyerSavings?: ?number,
  secondBuyerUseOfSecondPillar?: ?boolean,
  secondBuyerSecondPillar?: ?number,
  secondBuyerUseOfThirdPillar?: ?boolean,
  secondBuyerThirdPillar?: ?number,
  maximumBudget?: ?number,
  buyApartment?: ?boolean,
  buyHouse?: ?boolean,
  minNumberOfBedrooms?: ?number,
  buyGroundFloor?: ?boolean,
  buyIntermediateFloor?: ?boolean,
  buyTopFloor?: ?boolean,
  hasLandForSale?: ?boolean,
  step?: ?DevelopmentRegistrationStep,
|};
export type DevelopmentSecondBuyerStepUpsertFormMutationVariables = {|
  input: UpsertDevelopmentRegistrationFormInput
|};
export type DevelopmentSecondBuyerStepUpsertFormMutationResponse = {|
  +upsertDevelopmentRegistrationForm: ?{|
    +form: ?{|
      +id: string,
      +step: ?DevelopmentRegistrationStep,
      +secondBuyerFirstName: ?string,
      +secondBuyerLastName: ?string,
      +secondBuyerDateOfBirth: ?string,
      +secondBuyerPhoneNumber: ?string,
      +secondBuyerSavings: ?number,
      +secondBuyerAnnualRevenues: ?number,
      +secondBuyerNationality: ?{|
        +id: string,
        +name: string,
      |},
      +secondBuyerOccupation: ?{|
        +id: string
      |},
      +secondBuyerWorkPermit: ?{|
        +id: string
      |},
    |}
  |}
|};
export type DevelopmentSecondBuyerStepUpsertFormMutation = {|
  variables: DevelopmentSecondBuyerStepUpsertFormMutationVariables,
  response: DevelopmentSecondBuyerStepUpsertFormMutationResponse,
|};
*/


/*
mutation DevelopmentSecondBuyerStepUpsertFormMutation(
  $input: UpsertDevelopmentRegistrationFormInput!
) {
  upsertDevelopmentRegistrationForm(input: $input) {
    form: developmentRegistrationForm {
      id
      step
      secondBuyerFirstName
      secondBuyerLastName
      secondBuyerDateOfBirth
      secondBuyerPhoneNumber
      secondBuyerSavings
      secondBuyerAnnualRevenues
      secondBuyerNationality {
        id
        name
      }
      secondBuyerOccupation {
        id
      }
      secondBuyerWorkPermit {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpsertDevelopmentRegistrationFormPayload",
    "kind": "LinkedField",
    "name": "upsertDevelopmentRegistrationForm",
    "plural": false,
    "selections": [
      {
        "alias": "form",
        "args": null,
        "concreteType": "DevelopmentRegistrationForm",
        "kind": "LinkedField",
        "name": "developmentRegistrationForm",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "step",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "secondBuyerFirstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "secondBuyerLastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "secondBuyerDateOfBirth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "secondBuyerPhoneNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "secondBuyerSavings",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "secondBuyerAnnualRevenues",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Dictionary",
            "kind": "LinkedField",
            "name": "secondBuyerNationality",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Dictionary",
            "kind": "LinkedField",
            "name": "secondBuyerOccupation",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Dictionary",
            "kind": "LinkedField",
            "name": "secondBuyerWorkPermit",
            "plural": false,
            "selections": (v2/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DevelopmentSecondBuyerStepUpsertFormMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DevelopmentSecondBuyerStepUpsertFormMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "f5ffe563706bb3932a4a6e020cdbaa94",
    "id": null,
    "metadata": {},
    "name": "DevelopmentSecondBuyerStepUpsertFormMutation",
    "operationKind": "mutation",
    "text": "mutation DevelopmentSecondBuyerStepUpsertFormMutation(\n  $input: UpsertDevelopmentRegistrationFormInput!\n) {\n  upsertDevelopmentRegistrationForm(input: $input) {\n    form: developmentRegistrationForm {\n      id\n      step\n      secondBuyerFirstName\n      secondBuyerLastName\n      secondBuyerDateOfBirth\n      secondBuyerPhoneNumber\n      secondBuyerSavings\n      secondBuyerAnnualRevenues\n      secondBuyerNationality {\n        id\n        name\n      }\n      secondBuyerOccupation {\n        id\n      }\n      secondBuyerWorkPermit {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '414261aef725e54b3a80afafe83b7842';

export default node;
